/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResponseForAgentText extends models.BaseForAgentResponse {
    constructor() {
        super();
        this.setDiscriminator("Text");
    }

    getFixupPrototypeFunction() { return ResponseForAgentText.fixupPrototype; }

    static newInstance(model: Partial<ResponseForAgentText>): ResponseForAgentText {
        let obj = Object.assign(new ResponseForAgentText(), model);
        ResponseForAgentText.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResponseForAgentText>): ResponseForAgentText {
        if (!model) return null;
        return ResponseForAgentText.newInstance(<ResponseForAgentText> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResponseForAgentText) {
        if (!obj) return;

        models.ResponseForAgentText.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResponseForAgentText): boolean {
        if (models.BaseForAgentResponse.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ResponseForAgentText.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Text response
     */
    value: string;

}
